import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Routes } from '../../routing';
import { string } from 'prop-types';
import StyedFooter from './BottomFooter.style';
// If user logged out width is 100% and not offset left 300px to accomodate Login screen.

const BottomFooter = ({ footerType }) => {
  return (
    <StyedFooter
      className="bottomfooter"
      footerType={footerType}
      data-testid="footer-component"
    >
      <section>
        <ul className="bottomfooter__links">
          <li>
            <Link to={Routes.terms}>
              <FormattedMessage
                id="cta.terms"
                description="Footer Terms and Conditions link text"
                defaultMessage="Terms and Conditions"
              />
            </Link>
          </li>
        </ul>
        <small>
          <FormattedMessage
            id="footer.copyright"
            description="Footer copyright text"
            defaultMessage="Copyright © {year} AGI"
            values={{ year: new Date().getFullYear() }}
          />
        </small>
      </section>
    </StyedFooter>
  );
};

BottomFooter.propTypes = {
  footerType: string
};

export default BottomFooter;



// WEBPACK FOOTER //
// ./src/components/BottomFooter/BottomFooter.js